import script from "./share.modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./share.modal.vue?vue&type=script&lang=ts&setup=true"

import "./share.modal.vue?vue&type=style&index=0&id=0013ac0e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0013ac0e"]])

export default __exports__